import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Star } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a08e3a5b-1647-495d-beb7-38e04e36fd68/images/38a05ada6bddd28b8ae7003adc00a2ed10543bbcc8c36b27214af10051b18baf.png";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden bg-[#050505]">
      {/* background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      {/* Gradient overlays for readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/85 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/60" />

      <div className="relative max-w-7xl mx-auto px-6 pt-40 pb-24 min-h-screen flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="h-px w-10 bg-blue-500" />
            <span className="text-blue-500 uppercase text-xs tracking-[0.3em] font-semibold">
              Mobile Detailing · Est. 2018
            </span>
          </div>

          <h1 className="font-heading text-white text-5xl md:text-7xl lg:text-[5.5rem] leading-[0.95] tracking-tighter font-light">
            Your car,
            <br />
            <span className="font-medium">restored to obsession.</span>
          </h1>

          <p className="mt-8 text-lg md:text-xl text-zinc-400 max-w-xl leading-relaxed">
            A studio-grade detailing service that comes to you. Hand-finished by certified
            specialists. Booked in under 60 seconds.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#booking"
              data-testid="hero-book-btn"
              className="group inline-flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-500 text-white px-9 py-5 font-medium tracking-wide transition-colors"
            >
              Book an appointment
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#services"
              data-testid="hero-services-btn"
              className="inline-flex items-center justify-center gap-3 border border-white/20 hover:border-white/40 bg-white/0 hover:bg-white/5 backdrop-blur-md text-white px-9 py-5 transition-all"
            >
              View packages
            </a>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            className="mt-16 flex items-center gap-8 text-sm text-zinc-500"
          >
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={14} fill="#3B82F6" stroke="#3B82F6" />
                ))}
              </div>
              <span className="text-zinc-300">4.9</span>
              <span>/ 800+ details</span>
            </div>
            <div className="hidden sm:flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              <span>Available this week</span>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Decorative vertical text on the right */}
      <div className="hidden lg:block absolute right-10 bottom-24 text-zinc-700 text-xs tracking-[0.4em] uppercase rotate-90 origin-bottom-right">
        Scroll · Explore · Detail
      </div>
    </section>
  );
}
